module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_case_01-b8a5c452e951b6f89676ceeda126fba3.png";